module.exports = __webpack_public_path__ + "static/img/menu-gl.5ea553f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-gl.png
// module id = 2l4r
// module chunks = 2